module.exports = __webpack_public_path__ + "img/5.1f485869.webp";